// Copyright (c) 2016 Deere & Company

import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const setCustomer = (state, action) =>
    Customer.update(state, {
        $set: action.data
    });

const resetCustomer = () => getDefaultState().customer;

export default (state = getDefaultState().customer, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_TRACK_PIN_DETAILS]: resetCustomer,
        [actions.SET_CLAIM_TRACK_CUSTOMER_DETAILS]: setCustomer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/track/reducers/customer.js